// guessing this is going to where my geto theme placement is going to be....

export default  {
    primaryColor: '#222122',
    secondaryColor: '#E4D6BF',
    highlightColor: '#A6704B',
    breakpoints: {
        mobile: '(max-width: 550px)',
        tablet: '(max-width: 800px)'
    }
}